import { HttpClient } from "../httpClient";

const httpClient = new HttpClient();

const login  = (data: any) => {
    return httpClient.post(`Login`, data);
}

const passChanging = (data:any) => {
    return httpClient.patch(`Account/password`,data)
}

const forgotPassword = (data:any) => {
    return httpClient.post(`Login/account/forgot`,data)
}


const loginService = {
    login,
    passChanging,
    forgotPassword,
};

export default loginService;